<template>
<div>
  <el-table :data="tableData"
            border default-expand-all
            :max-height="tableHeight"
            :row-style="{'height':'33px'}"
            :header-cell-style="{'text-align':'center'}"
            style="width: 100%;margin-top: 20px;text-align: center"
            :cell-style="{'text-align':'center', 'padding':'0'}">
    <el-table-column prop="id" label="序号" width="80">
      <template slot-scope="scope">
        {{ scope.$index + 1 }}
      </template>
    </el-table-column>
    <el-table-column label="价格区间" max-width="30%">
      <el-table-column label="起(不含)" width="300" >
        <template slot-scope="scope">
          <span>{{scope.row.startPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column label="止(包含)" width="300">
        <template slot-scope="scope">
          <span>{{scope.row.endPrice}}</span>
        </template>
      </el-table-column>
    </el-table-column>
    <el-table-column label="返款手续费" prop="oncePrice" align="center" >
      <template slot-scope="scope">
        <span>{{scope.row.backupShowSerPrice }}</span>
      </template>
    </el-table-column>
    <el-table-column label="立返" prop="oncePrice" align="center" >
      <template slot-scope="scope">
        <span>{{scope.row.backupServicePrice}}</span>
      </template>
    </el-table-column>
    <el-table-column label="货返" prop="onceGoods" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.goodReturnServicePrice}}</span>
        </template>
    </el-table-column>
  </el-table>
  <el-pagination
      :page-sizes="[20, 50, 100, 200]"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="pagination.pageNum"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      @size-change="handlePageSizeChange"
      @current-change="handlePageNumChange"
      background
      style="margin-top:5px;float: right;margin-bottom: 10px">
  </el-pagination>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD';
import {getCustoMoneySetting} from "../../api/b2cbusiness/b2c_customoneysetting";
export default {
  name: "PriceStandardComponent",
  mixins: [MixinCUD],
  props: ["dataSelectParam"],
  data(){
    return {
      selectMenuValue: {},
      tableData:[],
      tableHeight: 650,
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    getCustoMoneySetting({cmsettingId:0, b2cTaskTypeId:this.selectMenuValue.id, startPrice:0, endPrice:0}, this.pagination).then(
        res => {
          console.log(res.data);
          if (res.success){
            this.tableData = res.data.records;
            this.pagination.pageNum = res.data.current;
            this.pagination.pageSize = res.data.size;
            this.pagination.total = res.data.total;
          }
        }
    );
  },
  methods: {
    getData(){
      //console.log("getData")
      getCustoMoneySetting({cmsettingId:0, b2cTaskTypeId:this.selectMenuValue.id, startPrice:0, endPrice:0}, this.pagination).then(
          res => {
            console.log(res.data);
            if (res.success){
              this.tableData = res.data.records;
              this.pagination.pageNum = res.data.current;
              this.pagination.pageSize = res.data.size;
              this.pagination.total = res.data.total;
            }
          }
      ).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  },
  watch:{
    dataSelectParam(val){
      console.log("+_+_+_+_+_+_",val)
      this.selectMenuValue = val;
      this.getData();
    }
  }
}
</script>

<style scoped>

</style>
